import Resource from '../../../api/resources/Resource'

class SubportionPrintServices extends Resource {
    async getSubportionLabelsReportForPrinting(labId, casId, samId, porId, subportions) {
        return this.axios.put(`/common/laboratories/${labId}/cases/${casId}/samples/${samId}/portions/${porId}/printSubportionLabels`,
            subportions,
            {
                headers: {
                    type: 'application/pdf'
                },
                responseType: 'text'
            }).then(response => response.data)
    }
}

export default new SubportionPrintServices()
